import {Component,OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {OpeLog,TypeOpeLog} from "@domain/admin/ca/ope-log";
import {Sorting} from "@domain/common/list-view/sorting";
import {SuiviReleveListItemComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-list-item.component";

/**
 * Composant de la liste du suivi des relevés de cartes
 *
 * @author Guillaume TRAVOT
 * @date 18/03/2026
 */
@Component({
    host: {'data-test-id': 'suivi-releve-liste'},
    selector: 'suivi-releve-liste',
    templateUrl: './suivi-releve-liste.component.html'
})
export class SuiviReleveListeComponent implements OnInit {
    /** Liste des logs d'opérations cartes */
    listeSuiviReleve: ListView<OpeLog, SuiviReleveListItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     */
    constructor(private translateService: TranslateService) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        this.initListe();
    }

    /**
     * Initialisation de la liste
     */
    private initListe(): void {
        //Création de la liste
        this.listeSuiviReleve = new ListView<OpeLog, SuiviReleveListItemComponent>({
            uri: '/controller/ImportCA/suiviReleve',
            title: this.translateService.instant('admin.frais.cartes.suivi.title'),
            component: SuiviReleveListItemComponent,
            defaultOrder: '-idOpeLog',
            isFilter: true,
            listeFilters: [
                {
                    clef: 'typeOpeLog',
                    title: this.translateService.instant('admin.frais.cartes.suivi.type'),
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    listeValues: [
                        {
                            code: TypeOpeLog.IMPORT,
                            libelle: this.translateService.instant('admin.frais.cartes.suivi.typeImport')
                        },
                        {
                            code: TypeOpeLog.REINTEGRATION,
                            libelle: this.translateService.instant('admin.frais.cartes.suivi.typeReintegration')
                        }
                    ],
                    multiple: true
                },
                {
                    clef: 'date',
                    title: this.translateService.instant('admin.frais.cartes.suivi.date'),
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    type: TypeFilter[TypeFilter.DATE],
                    ignoreHeures: true
                }
            ]
        });

        //Gestion du tri
        this.listeSuiviReleve.columns = [
            {key: 'idOpeLog', title: this.translateService.instant('admin.frais.cartes.suivi.numero')},
            {key: 'typeOpeLog', title: this.translateService.instant('admin.frais.cartes.suivi.type')},
            {key: 'date', title: this.translateService.instant('admin.frais.cartes.suivi.date')},
            {key: 'nbOpe', title: this.translateService.instant('admin.frais.cartes.suivi.nbOpe')}
        ];
        this.listeSuiviReleve.sorting = new Sorting(this.listeSuiviReleve.columns, '-idOpeLog');

        //Gestion de la persistance des filtres
        this.listeSuiviReleve.isPersistFilters = true;
        this.listeSuiviReleve.className = 'SuiviReleveListeComponent';
    }
}